export var AESStorageProps;
(function (AESStorageProps) {
  let Type;
  (function (Type) {
    Type["local"] = "localStorage";
    Type["session"] = "sessionStorage";
  })(Type = AESStorageProps.Type || (AESStorageProps.Type = {}));
})(AESStorageProps || (AESStorageProps = {}));